import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: [0.33, 1, 0.68, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`text-xs md:text-sm uppercase tracking-[0.25em] font-semibold ${
      light ? "text-gooi-offwhite/70" : "text-gooi-forest"
    }`}
  >
    {children}
  </p>
);
